import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useTheme } from "../../../../Hooks";
import ViewButton from "./ViewButton/ViewButton";
import ViewButtonContainer from "./ViewButtonContainer/ViewButtonContainer";
import InformationSection from "./InformationSection/InformationSection";
import InformationRow from "./InformationRow/InformationRow";
import ToolTip from "../../../ToolTip/Tooltip";
import { SvgComponent } from "../../../SvgComponent/SvgComponent";

function LeftSectionBody(props) {
    const { theme } = useTheme();

    return (
        <div className="mt-5" style={{ maxHeight: "calc(100vh - 50px)" }}>
            <div className="text-center mb-3">
                {props.showImage && (
                    <div
                        className={`mb-1 ${
                            props.img64 ? `` : `d-flex justify-content-center`
                        } `}
                        style={{ height: `70%` }}
                    >
                        {props.img64 ? (
                            <img
                                src={
                                    props.img64 ??
                                    "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png"
                                }
                                style={{
                                    borderRadius: "50%",
                                    width: "22%",
                                    margin: "0",
                                }}
                            ></img>
                        ) : (
                            <div
                                style={{
                                    backgroundColor: theme.color1,
                                    borderRadius: `50%`,
                                    margin: "0px",
                                    width: "110px",
                                    height: "110px",
                                }}
                            >
                                <SvgComponent
                                    iconName={props.icon}
                                    height="60"
                                    width="60"
                                    fill="white"
                                    style={{ margin: "25px" }}
                                />
                            </div>
                        )}
                    </div>
                )}

                {props.title !== undefined ? (
                    <div
                        style={{
                            position: "relative",
                            paddingTop: "20px",
                            display: "inline-block",
                            width: "100%",
                        }}
                    >
                        <h5
                            className="mb-1"
                            style={{
                                marginBottom: "10px !important",
                                fontSize: "2.4vh",
                                display: "inline-flex",
                                alignItems: "center",
                                wordBreak: "break-word",
                            }}
                        >
                            {props.title}
                            {props.Editar && (
                                <span
                                    style={{
                                        position: "relative",
                                        textAlign: "center",
                                        padding: "0.2vh 0.3vh",
                                        fontSize: "1.5vh",
                                    }}
                                >
                                  <ToolTip message="Editar">
                                    <div onClick={props.Editar}>
                                      <SvgComponent
                                          iconName="pencil"
                                          style={{
                                              cursor: "pointer",
                                              marginLeft: "3px",
                                              marginBottom: "1px",
                                          }}
                                          width="15px"
                                          height="15px"
                                      />
                                    </div>
                                  </ToolTip>
                                </span>
                            )}
                        </h5>
                        {props.subTitleRenderer ? (
                            props.subTitleRenderer()
                        ) : (
                            <h5 style={{ fontSize: "1.4vh" }}>{props.subTitle}</h5>
                        )}
                    </div>
                ) : (
                    <div className="p-1">
                        <Skeleton baseColor={theme.skeletonColor} height="2rem" />
                    </div>
                )}
            </div>
            <ViewButtonContainer>
                {props.actions.map((action) => {
                        return (
                            <ViewButton
                                key={action.label}
                                ToolTipMessage={action.label}
                                icon={action.icon}
                                onClick={action.onClick}
                                IconSize={action.IconSize}
                                Size={action.Size}
                                active={action.active}
                                disabled={action.disabled}
                            />
                        );
                })}
            </ViewButtonContainer>
            <hr></hr>
            <div className="ml-3 mb-5">
                {props.sections &&
                    props.sections.map((section) => {
                        return (
                            section.details.filter((el) => {
                                return el.informacion;
                            }).length > 0 && (
                                <InformationSection key={section.title} title={section.title}>
                                    {section.details &&
                                        section.details.map((detail) => {
                                            return (
                                                detail.informacion && (
                                                    <InformationRow
                                                        key={detail.titulo}
                                                        titulo={detail.titulo}
                                                        informacion={detail.informacion}
                                                        descripcion={detail.descripcion}
                                                    ></InformationRow>
                                                )
                                            );
                                        })}
                                </InformationSection>
                            )
                        );
                    })}
            </div>
        </div>
    );
}
export default LeftSectionBody;
